__turbopack_context__.v({
  "filterWrapper": "searchFilters-module-scss-module__Yy3naq__filterWrapper",
  "title": "searchFilters-module-scss-module__Yy3naq__title",
  "wrapper": "searchFilters-module-scss-module__Yy3naq__wrapper",
});
